const eventsConstants = {
  ON_CLICK: "click",
  ON_MOUSE_ENTER: "mouseenter",
  ON_MOUSE_LEAVE: "mouseleave",
  ON_MOUSE_UP: "mouseup",
  ON_TOUCH_END: "touchend",
  ON_FOCUS: "focus",
  ON_BLUR: "blur",
}

export default eventsConstants
